module.exports = __webpack_public_path__ + "vue/img/icon-11.390eb84f.png";